validation = function () {

	var objValidation = {};
	//var errors = [];
	var messages = {
		'default': 'You must enter valid data.',
		'required': 'This field is required.',
		'numeric': 'You must enter a valid number.',
		'alpha': 'You must enter only alphabetic characters, spaces, and hyphens.',
		'email': 'You must enter a valid email address.',
		'phone': 'You must enter a valid phone number.',
		'date': 'You must enter a valid date (mm/dd/yy).',
		'integer': 'Must enter a valid number greater than 0',
		'url': 'Must enter a valid url',
		'vote': 'Your vote must be between 0 and 100',
		'key': 'You have entered an invalid key',
		'file-ext': 'This type of file is not allowed',
		'numeric-greater-than-zero': 'You must enter a number greater than 0.'
	};

	objValidation.addErrorMessage = function (key, value) {
		messages[key] = value;
	};

	/**
	 * Purpose, check upload file extension against a blacklist.
	 * Maybe one day will find whitelisting shorter...
	 * Maybe one day have the blackList be fed by the db... or ini file
	 * @param  {[type]}  filename [description]
	 * @return {Boolean}          [description]
	 */
	objValidation.isValidExtension = function(filename){
		var blackList = {
			'.exe'  : 1,
			'.sh' : 1,
			'.js': 1
		};
		var re = /\..+$/;
		var ext = filename.match(re);

		if (blackList[ext]) {
			return false;
		} else {
			return true;
		}
	};

	objValidation.isNumeric = function(value){
		var numericExpression = /^[0-9]+$/;

		if ( value.match(numericExpression) ) {
			return true;
		}

		return false;
	};

	objValidation.isInteger = function(value){
		var numericExpression = /^[0-9]+$/;

		if ( value.match(numericExpression) ) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isEmpty = function(value){
		if ( value.length < 1 ) {
			return true;
		}
		if ( value === '[]') {
			return true;
		}
		return false;
	};

	objValidation.isZero = function(value){
		if ( value.length > 0 && value.charAt(0) < 1 ){
			return true;
		}
		return false;
	};

	objValidation.isUrl = function(value){
		var urlExpression = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

		if ( value.match(urlExpression) ) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isEmail = function(value){
		var emailExpression = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;

		if ( value.match(emailExpression) ) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isPhone = function(value){
		var phoneExpression = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
		var international = /^\+(?:[0-9] ?){6,14}[0-9]$/;
		var internationalEPP = /^\+[0-9]{1,3}\.[0-9]{4,14}(?:x.+)?$/;

		if ( value.match(phoneExpression) || value.match(international) || value.match(internationalEPP) ) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isAlpha = function(value){
		// Allow a-z, A-Z, or space, hyphen
		var alphaExpression = /^[a-zA-Z -]+$/;

		if (value.match(alphaExpression)) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isDate = function(value){
		// Trying to use validity here breaks everything. Until the proposal
		// form can be completely refactored to use validity, we can simply use
		// the regex that validity would use.
		var dateExpression = /^((0?\d)|(1[012]))\/([012]?\d|30|31)\/\d{1,4}$/;

		if (value.match(dateExpression)) {
			return true;
		}

		// only return false if not empty
		if (value.length > 0) {
			return false;
		}

		return true;
	};

	objValidation.isGreaterThanZero = function(value) {
		return +value > 0;
	};

	objValidation.displayMessage = function(type) {
		var message = '';
		if (typeof messages[type] === 'undefined') {
			message = messages['default'];
		} else {
			message = messages[type];
		}

		return messages[type];
	};

	objValidation.validate = function(field) {
		// field options actions
		// The pattern needs to match any DOM ID in the format type-ID-field name. ie: field-12345-displayText and step-12345-name
		// hasErrors is a global variable defined in default.html.php that is used by approvalForm.js to determine whether to save the
		// field options or to close/cancel the box as expected.

		var theField = ($(field).attr('id')).match(/.*-.*-(.*)/);
		if (theField !== null) {
			if (theField[1] === 'displayText' )  {
				if ($(field).val() === '') {
					if (! $(field).closest('li').hasClass('curriculog-remove-warning-highlight')) {
						$(field).closest('li').addClass('curriculog-remove-warning-highlight');
						$(field).closest('.field-options-fields').append('<div class="options-warning">You must give your field a name.</div>');
					}
					hasErrors = true;
				} else {
					$(field).closest('li').removeClass('curriculog-remove-warning-highlight');
					$(field).siblings('.options-warning').remove();
					hasErrors = false;
				}
			} else if (theField[1] === 'maxLength') {
				if( ($(field).val() !== '') && ( !(this.isInteger( $(field).val() )) )) {
					if (! $(field).closest('li').hasClass('curriculog-remove-warning-highlight')) {
						$(field).closest('li').addClass('curriculog-remove-warning-highlight');
						$(field).closest('.field-options-fields').append('<div class="options-warning">You must enter an integer.</div>');
					}
					hasErrors = true;
				} else {
					$(field).closest('li').removeClass('curriculog-remove-warning-highlight');
					$(field).siblings('.options-warning').remove();
					hasErrors = false;
				}
			} else if(theField[1] === 'name') {
				if ($(field).val() === '') {
					if (! $(field).closest('fieldset').hasClass('curriculog-remove-warning-highlight')) {
						$(field).closest('fieldset').addClass('curriculog-remove-warning-highlight');
						$(field).closest('.option-group').append('<div class="options-warning">You must give your field a name.</div>');
					}
					hasErrors = true;
				} else {
					$(field).closest('fieldset').removeClass('curriculog-remove-warning-highlight');
					$(field).siblings('.options-warning').remove();
					hasErrors = false;
				}
			} else if (theField[1] === 'voteThreshold') {
				if ( ($(field).val() !== '') && ( ( !(this.isInteger( $(field).val() )) ||  ( $(field).val() < 0) || ($(field).val() > 100)) )) {
					if (! $(field).closest('fieldset').hasClass('curriculog-remove-warning-highlight')) {
						$(field).closest('fieldset').addClass('curriculog-remove-warning-highlight');
						$(field).closest('.option-group').append('<div class="options-warning clearfix">You must enter an integer between 0 and 100.</div>');
					}
					hasErrors = true;
				} else {
					$(field).closest('fieldset').removeClass('curriculog-remove-warning-highlight');
					$(field).parent().siblings('.options-warning').remove();
					hasErrors = false;
				}
			}
		}

	};

	objValidation.getInputType = function(input){
		var inputType = $(input).attr('type');
		if (inputType === 'hidden') {
			inputType = 'smartfield';
		} else if (inputType === undefined || inputType === null) {
			inputType = 'textarea';
		}

		return inputType;
	};

	objValidation.getSpanId = function(input, inputType){
		var spanId = $(input).attr('id') + 'Error';
		if (inputType === undefined || inputType === null) {
			inputType = objValidation.getInputType(input);
		}

		if ((inputType === 'checkbox' || inputType === 'radio' || inputType === 'smartfield') && spanId.split('-').length > 2 ) {
			spanId = spanId.substring(0,spanId.lastIndexOf('-'));
		}

		return spanId;
	};

	objValidation.getInputDetails = function(input){
		var inputType = objValidation.getInputType(input);
		var spanId = objValidation.getSpanId(input, inputType);

		return [inputType, spanId];
	};

	objValidation.addError = function(input, type, valid, required, callback) {
		var details = objValidation.getInputDetails(input);
		var inputType = details[0];
		var spanId = details[1];
		var isAssessment = $(input).closest('.section-fieldset').hasClass('widget-assessment');

		//Only include this variable if we are working with a Backbone app
		if (app.formView) {
			var proposal = app.formView.model;
		}


		if ($('span#' + spanId).size() < 1 ) {
			var errorMessageHolder = '<span id="' + spanId + '" class="error"></span>';
			if ($(input).parents(':eq(1), :eq(2), :eq(3)').hasClass('section-fieldset')){
				var specialFields = ['checkbox', 'radio'];
				var parent = $(input).parents('.option-groups');
				if ($(parent).find('.fieldset-buttons').size() > 0) {
					$(parent).find('.fieldset-buttons').before(errorMessageHolder);
				} else {
					$(parent).append(errorMessageHolder);
				}

				if (jQuery.inArray(inputType, specialFields) > -1) {
					$(input).parents('fieldset:first').addClass('error');
				} else {

					$(input).addClass('error');
				}
			} else {
				$(input).after(errorMessageHolder);
				$(input).addClass('error');
			}

			if (!(valid)) {
				$('span#' + spanId).html(objValidation.displayMessage(type));
			}

			var errorText;
			if (isAssessment && (proposal.get('status') === 'unlaunched')) {
				errorText = 'You may not launch a proposal with blank assessments';
			} else {
				errorText = 'This field is required';
			}

			if (required) {
				if ($('span#' + spanId).html().length > 0) {
					$('span#' + spanId).append('<br />'+errorText);
				} else {
					$('span#' + spanId).html(errorText);
				}
			}

		}

		callback && callback();

		return objValidation.hasErrors();

	};

	objValidation.removeError = function(input, type, callback, clearFormCallback) {
		var spanId = objValidation.getSpanId(input);
		$('span#' + spanId).remove();
		$(input).removeClass('error');

		// remove 'This field is required' from checkbox/radio fields
		var altSpanId = spanId.replace('Error','');
		$('span#' + altSpanId).remove();
		$('.' + altSpanId).removeClass('error');

		callback && callback();

		if (objValidation.hasErrors() === 0) {
			clearFormCallback && clearFormCallback();
		}

		return objValidation.hasErrors();
	};

	objValidation.hasErrors = function(form) {
		form = form ? $(form) : $;
		return form.find('fieldset.error, input.error, textarea.error').length;
	};

	objValidation.updateForm = function(input, valid, required, type, removeCallback, clearFormCallback, addCallback) {

		// first remove any previous errors
		objValidation.removeError(input, type, removeCallback, clearFormCallback);

		if (typeof required === 'undefined') {
			required = false;
		}

		if (valid && ! required) {
			return objValidation.removeError(input, type, removeCallback, clearFormCallback);
		} else {
			return objValidation.addError(input, type, valid, required, addCallback);
		}
	};

	return objValidation;
};
